module.exports = __webpack_public_path__ + "static/media/Admin Help Documentation.92046012.pdf";